/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { IMG, Stack, FontAwesomeIcon } from "components";
import { List } from "../PersonalImageInstructions/PersonalImageInstructions";
import Correct1 from "./1-correct.png";
import Wrong1 from "./1-wrong.png";
import Correct2 from "./2-correct.png";
import Wrong2 from "./2-wrong.png";
import Correct3 from "./3-correct.png";
import Wrong3 from "./3-wrong.png";
import Correct4 from "./4-correct.png";
import Wrong4 from "./4-wrong.png";
import Correct5 from "./5-correct.png";
import Wrong5 from "./5-wrong.png";
import { FC } from "react";
import { useTranslation } from "react-i18next";

type InstructionsProps = {
  note: string[];
  correctImage: string;
  wrongImage: string;
};

const Instruction: FC<InstructionsProps> = ({
  note,
  correctImage,
  wrongImage,
}) => {
  return (
    <Stack>
      <Stack className="p-8 mb-8 -bg--theme-colors-surface-neutral-level02 border -border-theme-colors-border-neutral-11 rounded-border-eadius -text--theme-colors-text-body">
        <ul className="list-disc">
          {note.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </Stack>
      <div className="grid grid-cols-2 gap-s15">
        <Stack className="items-center space-y-5 h-full">
          <IMG src={correctImage} alt="correct" className="w-full h-full" />
          <span className="-text--theme-colors-success-default">
            <FontAwesomeIcon name="fa-circle-check" size="2x" />
          </span>
        </Stack>
        <Stack className="items-center space-y-5 h-full">
          <IMG src={wrongImage} alt="wrong" className="w-full h-full" />
          <span className="-text--theme-colors-danger-default">
            <FontAwesomeIcon name="fa-circle-xmark" size="2x" />
          </span>
        </Stack>
      </div>
    </Stack>
  );
};

const PassportImagePage = () => {
  const { t } = useTranslation();

  const INSTRUCTIONS = [
    {
      note: [
        t("instructions.passport.steps", {
          returnObjects: true,
        })[0],
      ],
      correctImage: Correct1,
      wrongImage: Wrong1,
    },
    {
      note: [
        t("instructions.passport.steps", {
          returnObjects: true,
        })[1],
      ],
      correctImage: Correct2,
      wrongImage: Wrong2,
    },
    {
      note: [
        t("instructions.passport.steps", {
          returnObjects: true,
        })[2],
        t("instructions.passport.steps", {
          returnObjects: true,
        })[3],
      ],
      correctImage: Correct3,
      wrongImage: Wrong3,
    },
    {
      note: [
        t("instructions.passport.steps", {
          returnObjects: true,
        })[4],
      ],
      correctImage: Correct4,
      wrongImage: Wrong4,
    },
    {
      note: [
        t("instructions.passport.steps", {
          returnObjects: true,
        })[5],
      ],
      correctImage: Correct5,
      wrongImage: Wrong5,
    },
  ];

  return (
    <Stack className="lg:px-40">
      <Stack className="-bg--theme-colors-surface-neutral-level02 border -border-theme-colors-border-neutral-11 rounded-border-eadius p-8">
        <List
          title={t("instructions.passport.note.title")}
          items={
            t("instructions.passport.note.items", {
              returnObjects: true,
            }) as string[]
          }
        />
      </Stack>
      <Stack className="space-y-20 mt-5">
        {INSTRUCTIONS.map((item, index) => (
          <Instruction key={index} {...item} />
        ))}
      </Stack>
    </Stack>
  );
};

export default PassportImagePage;
